module.exports = __webpack_public_path__ + "static/media/image-6.6b59543f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-6.jpg
// module id = 21
// module chunks = 0